/** What kind of thing a stored document is, for the screens that have to send a reader somewhere.
 *
 * **One home, because two screens sending the same document to two different places is the
 * failure.** The evidence library has always decided this; the census's source trail did not and
 * linked every document to the statement review page, so a spreadsheet's link landed on a screen
 * that answered `not_extracted` — a failed read behind a link that worked. Both now ask here.
 */

/** Whether this document is a file of rows rather than a document to read.
 *
 * By **content type**, not by the kind someone chose from a dropdown: the kind is a label and the
 * content type was sniffed from the file's own bytes at upload. A statement mislabelled
 * "spreadsheet" would otherwise be offered an import that cannot work, and a spreadsheet labelled
 * "gas bill" would be sent to an extraction that refuses it.
 *
 * The three types are the ones the backend's own importer accepts (`evidence/csv_import.py`), so a
 * file this returns true for is a file that screen can actually read.
 */
export function isTabularContentType(contentType: string): boolean {
  return (
    contentType === "text/csv" ||
    contentType.includes("spreadsheetml") ||
    contentType === "application/vnd.ms-excel"
  );
}
